import React, { useEffect, useRef } from "react";
import "./Process.css";

const STEPS = [
  {
    num: "01",
    title: "Discovery & Assessment",
    desc: "Deep understanding of your background, aspirations, and target opportunities. Every recommendation flows from this foundation.",
  },
  {
    num: "02",
    title: "Profile & Brand Building",
    desc: "We craft your resume, LinkedIn presence, and personal narrative — positioning you as the candidate recruiters actively seek.",
  },
  {
    num: "03",
    title: "Skills & Interview Coaching",
    desc: "Targeted technical and behavioural prep for every stage — from initial screens to final-round panels.",
  },
  {
    num: "04",
    title: "Placement & Onboarding",
    desc: "We handle introductions, support offer negotiations, and ensure a smooth transition into your new role.",
  },
];

const Process = () => {
  const ref = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) =>
        entries.forEach((e) => {
          if (e.isIntersecting) e.target.classList.add("visible");
        }),
      { threshold: 0.08 }
    );
    ref.current?.querySelectorAll(".reveal").forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  return (
    <section className="process-wrapper" id="process" ref={ref}>
      {/* Background Liquid Animations */}
      <div className="process__bg-orb process__bg-orb--1"></div>
      <div className="process__bg-orb process__bg-orb--2"></div>

      <div className="process__inner">
        <div className="process__left reveal">
          <span className="eyebrow">How It Works</span>
          <h2 className="process__h2">
            A Structured Path<br />to Your Next Role
          </h2>
          <p className="process__sub">
            We follow a proven four-step methodology that puts your ambitions at
            the centre of every decision we make.
          </p>
        </div>

        <div className="process__steps-wrap reveal reveal-delay-2">
          {/* Animated Liquid Timeline Line */}
          <div className="process__timeline-line">
            <div className="process__timeline-glow"></div>
          </div>

          {STEPS.map((s, i) => (
            <div className="process__step glass glass-hover floating-card" key={s.num} style={{ animationDelay: `${i * 0.5}s` }}>
              <div className="process__step-num">{s.num}</div>
              <div className="process__step-body">
                <h4>{s.title}</h4>
                <p>{s.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Process;